import React from "react";
import RadioButtons from "src/components/common/RadioButton";
import CollapsibleMenu from "src/components/common/CollapsibleMenu";
import styles from "./styles.module.scss";
import * as Validators from "src/utils/validators";

const TxType = ({ onChange, txType, intermediary, collapsible }) => {
    const body = (
        <div className={[styles.section, styles.triplet].join(" ")}>
            {!collapsible && <div className={styles.title}>Type</div>}
            <div className={styles.input}>
                <RadioButtons
                    options={Validators.TX_TYPE_SELECT_OPTIONS(intermediary)}
                    dataTestId="select-tx-type"
                    value={txType}
                    setter={onChange}
                />
            </div>
        </div>
    );
    if (collapsible) {
        return (
            <CollapsibleMenu title="Type" dataTestId="init-tx-type">
                {body}
            </CollapsibleMenu>
        );
    }
    return body;
};

export default TxType;
